export const URL = "http://localhost:7175/api"

const endpoints = {
    // AUTHENTICATION
    "LOGIN": URL + "/Authentication/Login",
    "REGISTER": URL + "/Authentication/Register",
    "REFRESH": URL + "/Authentication/Refresh",
    // LOG
    "LOG_GETALL": URL + "/Log/GetAll",
    "LOG_GET": URL + "/Log/Get",
    "LOG_DELETE": URL + "/Log/Delete",
}

export default endpoints